import { ReplayTenIcon } from "../icons";
import { cn } from "../lib/cn";
import { getPlayerControlButtonClasses } from "../lib/shared-styles";

export type SeekBackwardButtonProps = {
  onSeekBackward: () => void;
  size?: "xs" | "sm" | "md" | "player" | "lg";
  color?: "black" | "white";
  disabled?: boolean;
  className?: string;
};

export function SeekBackwardButton({
  onSeekBackward,
  size = "md",
  color = "black",
  disabled = false,
  className,
}: SeekBackwardButtonProps) {
  return (
    <button
      type="button"
      onClick={onSeekBackward}
      disabled={disabled}
      aria-label="Seek backward 10 seconds"
      className={cn(
        getPlayerControlButtonClasses({ color, disabled }),
        {
          "size-[1.4rem]": size === "xs",
          "size-6.5": size === "sm",
          "size-8": size === "md" || size === "player",
          "size-12": size === "lg",
        },
        className,
      )}
      aria-disabled={disabled}
      data-testid="audio-seek-backward-button"
      data-size={size}
      data-color={color}
    >
      <ReplayTenIcon
        aria-hidden="true"
        className={cn("fill-current", {
          "size-[1.4rem]": size === "xs",
          "size-6.5": size === "sm",
          "size-8": size === "md" || size === "player",
          "size-12": size === "lg",
        })}
      />
    </button>
  );
}
